import React, { useState, useEffect } from 'react';
import PageTitle from '../components/common/PageTitle';
import { Container, Row, Col } from "shards-react";
import { withStyles } from "@material-ui/core/styles";
import PushNotificationComponent from "../components/common/PushNotification"

const useStyles = theme => ({
    root: {
      flexGrow: 1,
      width: '100%',
    },
      appBar: {
      position: 'relative',
    },
    title: {
      marginLeft: '2rem',
      flex: 1,
      color: 'white'
    },
    paper: {
      padding: '2rem',
      textAlign: 'center',
    },
    checkedIcon:{
        width: 16,
        height: 16,
    },
    option:{
          fontWeight: 600,
        fontSize:'0.75rem',
    },
    typography:{
        fontSize: '0.75rem'
    },
    select:{
        marginTop: '0',
        marginRight:'12px',
        padding: '0'
    },
    menu:{
        fontSize: '0.75rem'
    }
  });
  
function PushNotification(props) {
    const handleRedirect = () => {
        window.location.href = '/home'
    }
    return (
        <Container fluid className="main-content-container px-4 pb-4">
            <Row noGutters className="page-header pt-4">
                <PageTitle sm="12" title={"Nueva notificación"} className="text-sm-left" />
            </Row>
            <Row>
                <PushNotificationComponent user_id={props.match.params.user_id} onRefresh={() => {handleRedirect()}}/>
            </Row>
    </Container>
	)

}

export default withStyles(useStyles)(PushNotification);
